function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
module.exports = function (videojs) {
  /**
   * Registers the ChromecastButton Component with Video.js. Calls
   * {@link http://docs.videojs.com/Component.html#.registerComponent}, which will add a
   * component called `chromecastButton` to the list of globally registered Video.js
   * components. The `chromecastButton` is added to the player's control bar UI
   * automatically once {@link module:enableChromecast} has been called. If you would
   * like to specify the order of the buttons that appear in the control bar, including
   * this button, you can do so in the options that you pass to the `videojs` function
   * when creating a player:
   *
   * ```
   * videojs('playerID', {
   *    controlBar: {
   *       children: [
   *          'playToggle',
   *          'progressControl',
   *          'volumePanel',
   *          'fullscreenToggle',
   *          'chromecastButton',
   *       ],
   *    }
   * });
   * ```
   *
   * @param videojs {object} A reference to {@link http://docs.videojs.com/module-videojs.html|Video.js}
   * @see http://docs.videojs.com/module-videojs.html#~registerPlugin
   */

  /**
   * The Video.js Button class is the base class for UI button components.
   *
   * @external Button
   * @see {@link http://docs.videojs.com/Button.html|Button}
   */
  var ButtonComponent = videojs.getComponent('Button');

  /**
   * The ChromecastButton module contains both the ChromecastButton class definition and
   * the function used to register the button as a Video.js Component.
   * @module ChromecastButton
   */

  /** @lends ChromecastButton.prototype **/
  var ChromecastButton = /*#__PURE__*/function (_ButtonComponent) {
    _inherits(ChromecastButton, _ButtonComponent);
    var _super = _createSuper(ChromecastButton);
    /**
     * This class is a button component designed to be displayed in the
     * player UI's control bar. It opens the Chromecast menu when clicked.
     *
     * @constructs
     * @extends external:Button
     * @param player {Player} the video.js player instance
     */
    function ChromecastButton(player, options) {
      var _this;
      _classCallCheck(this, ChromecastButton);
      _this = _super.call(this, player, options);
      player.on('chromecastConnected', _this._onChromecastConnected.bind(_assertThisInitialized(_this)));
      player.on('chromecastDisconnected', _this._onChromecastDisconnected.bind(_assertThisInitialized(_this)));
      player.on('chromecastDevicesAvailable', _this._onChromecastDevicesAvailable.bind(_assertThisInitialized(_this)));
      player.on('chromecastDevicesUnavailable', _this._onChromecastDevicesUnavailable.bind(_assertThisInitialized(_this)));

      // Use the initial state of `hasAvailableDevices` to call the corresponding event
      // handlers because the corresponding events may have already been emitted before
      // binding the listeners above.
      if (player.chromecastSessionManager && player.chromecastSessionManager.hasAvailableDevices()) {
        _this._onChromecastDevicesAvailable();
      } else {
        _this._onChromecastDevicesUnavailable();
      }
      if (options.addCastLabelToButton) {
        _this.el().classList.add('vjs-chromecast-button-lg');
        _this._labelEl = document.createElement('span');
        _this._labelEl.classList.add('vjs-chromecast-button-label');
        _this._updateCastLabelText();
        _this.el().appendChild(_this._labelEl);
      } else {
        _this.controlText('Open Chromecast menu');
      }
      return _this;
    }

    /**
     * Overrides Button#buildCSSClass to return the classes used on the button element.
     *
     * @param el {DOMElement}
     * @see {@link http://docs.videojs.com/Button.html#buildCSSClass|Button#buildCSSClass}
     */
    _createClass(ChromecastButton, [{
      key: "buildCSSClass",
      value: function buildCSSClass() {
        return 'vjs-chromecast-button ' + (this._isChromecastConnected ? 'vjs-chromecast-casting-state ' : '') + (this.options_.addCastLabelToButton ? 'vjs-chromecast-button-lg ' : '') + ButtonComponent.prototype.buildCSSClass();
      }

      /**
       * Overrides Button#handleClick to handle button click events. Chromecast
       * functionality is handled outside of this class, which should be limited
       * to UI related logic.  This function simply triggers an event on the player.
       *
       * @fires ChromecastButton#chromecastRequested
       * @param el {DOMElement}
       * @see {@link http://docs.videojs.com/Button.html#handleClick|Button#handleClick}
       */
    }, {
      key: "handleClick",
      value: function handleClick() {
        this.player().trigger('chromecastRequested');
      }

      /**
       * Handles `chromecastConnected` player events.
       *
       * @private
       */
    }, {
      key: "_onChromecastConnected",
      value: function _onChromecastConnected() {
        this._isChromecastConnected = true;
        this._reloadCSSClasses();
        this._updateCastLabelText();
      }

      /**
       * Handles `chromecastDisconnected` player events.
       *
       * @private
       */
    }, {
      key: "_onChromecastDisconnected",
      value: function _onChromecastDisconnected() {
        this._isChromecastConnected = false;
        this._reloadCSSClasses();
        this._updateCastLabelText();
      }

      /**
       * Handles `chromecastDevicesAvailable` player events.
       *
       * @private
       */
    }, {
      key: "_onChromecastDevicesAvailable",
      value: function _onChromecastDevicesAvailable() {
        this.show();
      }

      /**
       * Handles `chromecastDevicesUnavailable` player events.
       *
       * @private
       */
    }, {
      key: "_onChromecastDevicesUnavailable",
      value: function _onChromecastDevicesUnavailable() {
        this.hide();
      }

      /**
       * Re-calculates which CSS classes the button needs and sets them on the buttons'
       * DOMElement.
       *
       * @private
       */
    }, {
      key: "_reloadCSSClasses",
      value: function _reloadCSSClasses() {
        if (!this.el_) {
          return;
        }
        this.el_.className = this.buildCSSClass();
      }

      /**
       * Updates the optional cast label text based on whether the chromecast is connected
       * or disconnected.
       *
       * @private
       */
    }, {
      key: "_updateCastLabelText",
      value: function _updateCastLabelText() {
        if (!this._labelEl) {
          return;
        }
        this._labelEl.textContent = this._isChromecastConnected ? this.localize('Disconnect Cast') : this.localize('Cast');
      }
    }]);
    return ChromecastButton;
  }(ButtonComponent);
  videojs.registerComponent('chromecastButton', ChromecastButton);
};